import React, { useContext, useEffect } from 'react';
import { useRouter } from 'next/router';

import analytics, { GA_CATEGORIES } from 'utils/client/analytics/analytics';
import { MessagingContext } from 'providers/messaging/MessagingContext';
import { MessagingAvailabilityReason } from 'providers/messaging/types';
import { useUbiContactPage } from 'utils/ubi/pages/useUbiContact';
import ErrorBoundary from 'components/ErrorBoundary';
import { useServerSideConstants } from 'providers/ServerSideConstantsProvider';

import LoadingContainer from '../LoadingContainer';
import MessagingContainer from '../MessagingContainer';
import EmailContainer from '../EmailContainer';
import LegalText from '../LegalText';
import UnavailableMessaging from '../UnavailableMessaging';

const Fallback = () => {
  const {
    verticalConfig: { features },
  } = useServerSideConstants();

  if (features.emailMessagingFallback) {
    return <EmailContainer />;
  }

  return <UnavailableMessaging />;
};

const ContactContent = () => {
  const ubi = useUbiContactPage();
  const { asPath } = useRouter();
  const { status, startMessaging } = useContext(MessagingContext);

  useEffect(() => {
    if (status.reason !== MessagingAvailabilityReason.LOADING) {
      analytics.trackEvent({
        category: GA_CATEGORIES.CONTACT_FORM,
        action: 'chat',
        label: status.isAvailable ? 'available' : 'not-available',
      });
    }
  }, [status]);

  if (status.reason === MessagingAvailabilityReason.LOADING) {
    return (
      <>
        <LoadingContainer />
        <LegalText />
      </>
    );
  }

  if (!status.isAvailable) {
    return <Fallback />;
  }

  return (
    <ErrorBoundary fallback={Fallback}>
      <MessagingContainer
        ubi={ubi}
        onCTA={() => {
          startMessaging?.();

          // Keeping this contactpage specific GA event, to be able to follow it over the migration. Over time, we'll be off GA.
          analytics.trackEvent({ category: GA_CATEGORIES.CONTACT_FORM, action: 'chat', label: 'started' });
          analytics.trackVirtualPageView(`${asPath}complete/`);
        }}
      />
      <LegalText />
    </ErrorBoundary>
  );
};

export default ContactContent;
